import {
  flocknoteCompleteCard,
  staxSetupCards,
  wepayMigrationCards,
} from "Dashboard/DashboardCards/mockData/cardConstants";

const { learnMore, notYetRegistered, submitted, pended, approved, rejected } =
  staxSetupCards;
const {
  learnMoreWepay,
  notYetRegisteredWepay,
  submittedWepay,
  pendedWepay,
  approvedWepay,
  rejectedWepay,
} = wepayMigrationCards;

const dismissDashboardCard = (postData) => {
  let resp = {
    isApp: false,
    success: true,
    cards: [flocknoteCompleteCard],
  };

  return resp;
};

export default dismissDashboardCard;
